import _toArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toArray.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { as as debugAssert, at as _isIOS, au as _isAndroid, av as _fail, aw as _getRedirectUrl, ax as _getProjectConfig, ay as _isIOS7Or8, az as _createError, aA as _assert, aB as AuthEventManager, aC as _getInstance, b as browserLocalPersistence, aD as _persistenceKeyName, a as browserSessionPersistence, aE as _getRedirectResult, aF as _overrideRedirectResult, aG as _clearRedirectOutcomes, aH as _castAuth } from './index-e3d5d3f4.js';
export { A as ActionCodeOperation, ag as ActionCodeURL, J as AuthCredential, G as AuthErrorCodes, aJ as AuthImpl, aM as AuthPopup, K as EmailAuthCredential, Q as EmailAuthProvider, U as FacebookAuthProvider, F as FactorId, aN as FetchProvider, W as GithubAuthProvider, V as GoogleAuthProvider, L as OAuthCredential, X as OAuthProvider, O as OperationType, M as PhoneAuthCredential, P as PhoneAuthProvider, m as PhoneMultiFactorGenerator, p as ProviderId, R as RecaptchaVerifier, aO as SAMLAuthCredential, Y as SAMLAuthProvider, S as SignInMethod, T as TotpMultiFactorGenerator, n as TotpSecret, Z as TwitterAuthProvider, aI as UserImpl, aA as _assert, aH as _castAuth, av as _fail, aL as _generateEventId, aK as _getClientVersion, aC as _getInstance, aE as _getRedirectResult, aF as _overrideRedirectResult, aD as _persistenceKeyName, a5 as applyActionCode, w as beforeAuthStateChanged, b as browserLocalPersistence, k as browserPopupRedirectResolver, a as browserSessionPersistence, a6 as checkActionCode, a4 as confirmPasswordReset, I as connectAuthEmulator, a8 as createUserWithEmailAndPassword, D as debugErrorMap, C as deleteUser, ad as fetchSignInMethodsForEmail, ao as getAdditionalUserInfo, o as getAuth, al as getIdToken, am as getIdTokenResult, aq as getMultiFactorResolver, j as getRedirectResult, N as inMemoryPersistence, i as indexedDBLocalPersistence, H as initializeAuth, t as initializeRecaptchaConfig, ab as isSignInWithEmailLink, a0 as linkWithCredential, l as linkWithPhoneNumber, d as linkWithPopup, g as linkWithRedirect, ar as multiFactor, x as onAuthStateChanged, v as onIdTokenChanged, ah as parseActionCodeURL, E as prodErrorMap, a1 as reauthenticateWithCredential, r as reauthenticateWithPhoneNumber, e as reauthenticateWithPopup, h as reauthenticateWithRedirect, ap as reload, ae as sendEmailVerification, a3 as sendPasswordResetEmail, aa as sendSignInLinkToEmail, q as setPersistence, _ as signInAnonymously, $ as signInWithCredential, a2 as signInWithCustomToken, a9 as signInWithEmailAndPassword, ac as signInWithEmailLink, s as signInWithPhoneNumber, c as signInWithPopup, f as signInWithRedirect, B as signOut, an as unlink, z as updateCurrentUser, aj as updateEmail, ak as updatePassword, u as updatePhoneNumber, ai as updateProfile, y as useDeviceLanguage, af as verifyBeforeUpdateEmail, a7 as verifyPasswordResetCode } from './index-e3d5d3f4.js';
import { querystringDecode } from '@firebase/util';
import '@firebase/app';
import 'tslib';
import '@firebase/logger';
import '@firebase/component';

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _cordovaWindow() {
  return window;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * How long to wait after the app comes back into focus before concluding that
 * the user closed the sign in tab.
 */
var REDIRECT_TIMEOUT_MS = 2000;
/**
 * Generates the URL for the OAuth handler.
 */
function _generateHandlerUrl(_x, _x2, _x3) {
  return _generateHandlerUrl2.apply(this, arguments);
}
/**
 * Validates that this app is valid for this project configuration
 */
function _generateHandlerUrl2() {
  _generateHandlerUrl2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(auth, event, provider) {
    var _a, _cordovaWindow4, BuildInfo, sessionDigest, additionalParams;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          // Get the cordova plugins
          _cordovaWindow4 = _cordovaWindow(), BuildInfo = _cordovaWindow4.BuildInfo;
          debugAssert(event.sessionId, 'AuthEvent did not contain a session ID');
          _context7.next = 4;
          return computeSha256(event.sessionId);
        case 4:
          sessionDigest = _context7.sent;
          additionalParams = {};
          if (_isIOS()) {
            // iOS app identifier
            additionalParams['ibi'] = BuildInfo.packageName;
          } else if (_isAndroid()) {
            // Android app identifier
            additionalParams['apn'] = BuildInfo.packageName;
          } else {
            _fail(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */);
          }
          // Add the display name if available
          if (BuildInfo.displayName) {
            additionalParams['appDisplayName'] = BuildInfo.displayName;
          }
          // Attached the hashed session ID
          additionalParams['sessionId'] = sessionDigest;
          return _context7.abrupt("return", _getRedirectUrl(auth, provider, event.type, undefined, (_a = event.eventId) !== null && _a !== void 0 ? _a : undefined, additionalParams));
        case 10:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _generateHandlerUrl2.apply(this, arguments);
}
function _validateOrigin(_x4) {
  return _validateOrigin2.apply(this, arguments);
}
function _validateOrigin2() {
  _validateOrigin2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(auth) {
    var _cordovaWindow5, BuildInfo, request;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _cordovaWindow5 = _cordovaWindow(), BuildInfo = _cordovaWindow5.BuildInfo;
          request = {};
          if (_isIOS()) {
            request.iosBundleId = BuildInfo.packageName;
          } else if (_isAndroid()) {
            request.androidPackageName = BuildInfo.packageName;
          } else {
            _fail(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */);
          }
          // Will fail automatically if package name is not authorized
          _context8.next = 5;
          return _getProjectConfig(auth, request);
        case 5:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return _validateOrigin2.apply(this, arguments);
}
function _performRedirect(handlerUrl) {
  // Get the cordova plugins
  var _cordovaWindow2 = _cordovaWindow(),
    cordova = _cordovaWindow2.cordova;
  return new Promise(function (resolve) {
    cordova.plugins.browsertab.isAvailable(function (browserTabIsAvailable) {
      var iabRef = null;
      if (browserTabIsAvailable) {
        cordova.plugins.browsertab.openUrl(handlerUrl);
      } else {
        // TODO: Return the inappbrowser ref that's returned from the open call
        iabRef = cordova.InAppBrowser.open(handlerUrl, _isIOS7Or8() ? '_blank' : '_system', 'location=yes');
      }
      resolve(iabRef);
    });
  });
}
/**
 * This function waits for app activity to be seen before resolving. It does
 * this by attaching listeners to various dom events. Once the app is determined
 * to be visible, this promise resolves. AFTER that resolution, the listeners
 * are detached and any browser tabs left open will be closed.
 */
function _waitForAppResume(_x5, _x6, _x7) {
  return _waitForAppResume2.apply(this, arguments);
}
/**
 * Checks the configuration of the Cordova environment. This has no side effect
 * if the configuration is correct; otherwise it throws an error with the
 * missing plugin.
 */
function _waitForAppResume2() {
  _waitForAppResume2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(auth, eventListener, iabRef) {
    var _cordovaWindow6, cordova, cleanup;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          // Get the cordova plugins
          _cordovaWindow6 = _cordovaWindow(), cordova = _cordovaWindow6.cordova;
          cleanup = function cleanup() {};
          _context9.prev = 2;
          _context9.next = 5;
          return new Promise(function (resolve, reject) {
            var onCloseTimer = null;
            // DEFINE ALL THE CALLBACKS =====
            function authEventSeen() {
              var _a;
              // Auth event was detected. Resolve this promise and close the extra
              // window if it's still open.
              resolve();
              var closeBrowserTab = (_a = cordova.plugins.browsertab) === null || _a === void 0 ? void 0 : _a.close;
              if (typeof closeBrowserTab === 'function') {
                closeBrowserTab();
              }
              // Close inappbrowser emebedded webview in iOS7 and 8 case if still
              // open.
              if (typeof (iabRef === null || iabRef === void 0 ? void 0 : iabRef.close) === 'function') {
                iabRef.close();
              }
            }
            function resumed() {
              if (onCloseTimer) {
                // This code already ran; do not rerun.
                return;
              }
              onCloseTimer = window.setTimeout(function () {
                // Wait two seeconds after resume then reject.
                reject(_createError(auth, "redirect-cancelled-by-user" /* AuthErrorCode.REDIRECT_CANCELLED_BY_USER */));
              }, REDIRECT_TIMEOUT_MS);
            }
            function visibilityChanged() {
              if ((document === null || document === void 0 ? void 0 : document.visibilityState) === 'visible') {
                resumed();
              }
            }
            // ATTACH ALL THE LISTENERS =====
            // Listen for the auth event
            eventListener.addPassiveListener(authEventSeen);
            // Listen for resume and visibility events
            document.addEventListener('resume', resumed, false);
            if (_isAndroid()) {
              document.addEventListener('visibilitychange', visibilityChanged, false);
            }
            // SETUP THE CLEANUP FUNCTION =====
            cleanup = function cleanup() {
              eventListener.removePassiveListener(authEventSeen);
              document.removeEventListener('resume', resumed, false);
              document.removeEventListener('visibilitychange', visibilityChanged, false);
              if (onCloseTimer) {
                window.clearTimeout(onCloseTimer);
              }
            };
          });
        case 5:
          _context9.prev = 5;
          cleanup();
          return _context9.finish(5);
        case 8:
        case "end":
          return _context9.stop();
      }
    }, _callee9, null, [[2,, 5, 8]]);
  }));
  return _waitForAppResume2.apply(this, arguments);
}
function _checkCordovaConfiguration(auth) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
  var win = _cordovaWindow();
  // Check all dependencies installed.
  // https://github.com/nordnet/cordova-universal-links-plugin
  // Note that cordova-universal-links-plugin has been abandoned.
  // A fork with latest fixes is available at:
  // https://www.npmjs.com/package/cordova-universal-links-plugin-fix
  _assert(typeof ((_a = win === null || win === void 0 ? void 0 : win.universalLinks) === null || _a === void 0 ? void 0 : _a.subscribe) === 'function', auth, "invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */, {
    missingPlugin: 'cordova-universal-links-plugin-fix'
  });
  // https://www.npmjs.com/package/cordova-plugin-buildinfo
  _assert(typeof ((_b = win === null || win === void 0 ? void 0 : win.BuildInfo) === null || _b === void 0 ? void 0 : _b.packageName) !== 'undefined', auth, "invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */, {
    missingPlugin: 'cordova-plugin-buildInfo'
  });
  // https://github.com/google/cordova-plugin-browsertab
  _assert(typeof ((_e = (_d = (_c = win === null || win === void 0 ? void 0 : win.cordova) === null || _c === void 0 ? void 0 : _c.plugins) === null || _d === void 0 ? void 0 : _d.browsertab) === null || _e === void 0 ? void 0 : _e.openUrl) === 'function', auth, "invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */, {
    missingPlugin: 'cordova-plugin-browsertab'
  });
  _assert(typeof ((_h = (_g = (_f = win === null || win === void 0 ? void 0 : win.cordova) === null || _f === void 0 ? void 0 : _f.plugins) === null || _g === void 0 ? void 0 : _g.browsertab) === null || _h === void 0 ? void 0 : _h.isAvailable) === 'function', auth, "invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */, {
    missingPlugin: 'cordova-plugin-browsertab'
  });
  // https://cordova.apache.org/docs/en/latest/reference/cordova-plugin-inappbrowser/
  _assert(typeof ((_k = (_j = win === null || win === void 0 ? void 0 : win.cordova) === null || _j === void 0 ? void 0 : _j.InAppBrowser) === null || _k === void 0 ? void 0 : _k.open) === 'function', auth, "invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */, {
    missingPlugin: 'cordova-plugin-inappbrowser'
  });
}
/**
 * Computes the SHA-256 of a session ID. The SubtleCrypto interface is only
 * available in "secure" contexts, which covers Cordova (which is served on a file
 * protocol).
 */
function computeSha256(_x8) {
  return _computeSha.apply(this, arguments);
}
function _computeSha() {
  _computeSha = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(sessionId) {
    var bytes, buf, arr;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          bytes = stringToArrayBuffer(sessionId); // TODO: For IE11 crypto has a different name and this operation comes back
          //       as an object, not a promise. This is the old proposed standard that
          //       is used by IE11:
          // https://www.w3.org/TR/2013/WD-WebCryptoAPI-20130108/#cryptooperation-interface
          _context10.next = 3;
          return crypto.subtle.digest('SHA-256', bytes);
        case 3:
          buf = _context10.sent;
          arr = Array.from(new Uint8Array(buf));
          return _context10.abrupt("return", arr.map(function (num) {
            return num.toString(16).padStart(2, '0');
          }).join(''));
        case 6:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return _computeSha.apply(this, arguments);
}
function stringToArrayBuffer(str) {
  // This function is only meant to deal with an ASCII charset and makes
  // certain simplifying assumptions.
  debugAssert(/[0-9a-zA-Z]+/.test(str), 'Can only convert alpha-numeric strings');
  if (typeof TextEncoder !== 'undefined') {
    return new TextEncoder().encode(str);
  }
  var buff = new ArrayBuffer(str.length);
  var view = new Uint8Array(buff);
  for (var i = 0; i < str.length; i++) {
    view[i] = str.charCodeAt(i);
  }
  return view;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var SESSION_ID_LENGTH = 20;
/** Custom AuthEventManager that adds passive listeners to events */
var CordovaAuthEventManager = /*#__PURE__*/function (_AuthEventManager) {
  _inherits(CordovaAuthEventManager, _AuthEventManager);
  var _super = _createSuper(CordovaAuthEventManager);
  function CordovaAuthEventManager() {
    var _this;
    _classCallCheck(this, CordovaAuthEventManager);
    _this = _super.apply(this, arguments);
    _this.passiveListeners = new Set();
    _this.initPromise = new Promise(function (resolve) {
      _this.resolveInialized = resolve;
    });
    return _this;
  }
  _createClass(CordovaAuthEventManager, [{
    key: "addPassiveListener",
    value: function addPassiveListener(cb) {
      this.passiveListeners.add(cb);
    }
  }, {
    key: "removePassiveListener",
    value: function removePassiveListener(cb) {
      this.passiveListeners.delete(cb);
    }
    // In a Cordova environment, this manager can live through multiple redirect
    // operations
  }, {
    key: "resetRedirect",
    value: function resetRedirect() {
      this.queuedRedirectEvent = null;
      this.hasHandledPotentialRedirect = false;
    }
    /** Override the onEvent method */
  }, {
    key: "onEvent",
    value: function onEvent(event) {
      this.resolveInialized();
      this.passiveListeners.forEach(function (cb) {
        return cb(event);
      });
      return _get(_getPrototypeOf(CordovaAuthEventManager.prototype), "onEvent", this).call(this, event);
    }
  }, {
    key: "initialized",
    value: function () {
      var _initialized = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.initPromise;
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function initialized() {
        return _initialized.apply(this, arguments);
      }
      return initialized;
    }()
  }]);
  return CordovaAuthEventManager;
}(AuthEventManager);
/**
 * Generates a (partial) {@link AuthEvent}.
 */
function _generateNewEvent(auth, type) {
  var eventId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return {
    type: type,
    eventId: eventId,
    urlResponse: null,
    sessionId: generateSessionId(),
    postBody: null,
    tenantId: auth.tenantId,
    error: _createError(auth, "no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */)
  };
}

function _savePartialEvent(auth, event) {
  return storage()._set(persistenceKey(auth), event);
}
function _getAndRemoveEvent(_x9) {
  return _getAndRemoveEvent2.apply(this, arguments);
}
function _getAndRemoveEvent2() {
  _getAndRemoveEvent2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(auth) {
    var event;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return storage()._get(persistenceKey(auth));
        case 2:
          event = _context11.sent;
          if (!event) {
            _context11.next = 6;
            break;
          }
          _context11.next = 6;
          return storage()._remove(persistenceKey(auth));
        case 6:
          return _context11.abrupt("return", event);
        case 7:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return _getAndRemoveEvent2.apply(this, arguments);
}
function _eventFromPartialAndUrl(partialEvent, url) {
  var _a, _b;
  // Parse the deep link within the dynamic link URL.
  var callbackUrl = _getDeepLinkFromCallback(url);
  // Confirm it is actually a callback URL.
  // Currently the universal link will be of this format:
  // https://<AUTH_DOMAIN>/__/auth/callback<OAUTH_RESPONSE>
  // This is a fake URL but is not intended to take the user anywhere
  // and just redirect to the app.
  if (callbackUrl.includes('/__/auth/callback')) {
    // Check if there is an error in the URL.
    // This mechanism is also used to pass errors back to the app:
    // https://<AUTH_DOMAIN>/__/auth/callback?firebaseError=<STRINGIFIED_ERROR>
    var params = searchParamsOrEmpty(callbackUrl);
    // Get the error object corresponding to the stringified error if found.
    var errorObject = params['firebaseError'] ? parseJsonOrNull(decodeURIComponent(params['firebaseError'])) : null;
    var code = (_b = (_a = errorObject === null || errorObject === void 0 ? void 0 : errorObject['code']) === null || _a === void 0 ? void 0 : _a.split('auth/')) === null || _b === void 0 ? void 0 : _b[1];
    var error = code ? _createError(code) : null;
    if (error) {
      return {
        type: partialEvent.type,
        eventId: partialEvent.eventId,
        tenantId: partialEvent.tenantId,
        error: error,
        urlResponse: null,
        sessionId: null,
        postBody: null
      };
    } else {
      return {
        type: partialEvent.type,
        eventId: partialEvent.eventId,
        tenantId: partialEvent.tenantId,
        sessionId: partialEvent.sessionId,
        urlResponse: callbackUrl,
        postBody: null
      };
    }
  }
  return null;
}
function generateSessionId() {
  var chars = [];
  var allowedChars = '1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  for (var i = 0; i < SESSION_ID_LENGTH; i++) {
    var idx = Math.floor(Math.random() * allowedChars.length);
    chars.push(allowedChars.charAt(idx));
  }
  return chars.join('');
}
function storage() {
  return _getInstance(browserLocalPersistence);
}
function persistenceKey(auth) {
  return _persistenceKeyName("authEvent" /* KeyName.AUTH_EVENT */, auth.config.apiKey, auth.name);
}
function parseJsonOrNull(json) {
  try {
    return JSON.parse(json);
  } catch (e) {
    return null;
  }
}
// Exported for testing
function _getDeepLinkFromCallback(url) {
  var params = searchParamsOrEmpty(url);
  var link = params['link'] ? decodeURIComponent(params['link']) : undefined;
  // Double link case (automatic redirect)
  var doubleDeepLink = searchParamsOrEmpty(link)['link'];
  // iOS custom scheme links.
  var iOSDeepLink = params['deep_link_id'] ? decodeURIComponent(params['deep_link_id']) : undefined;
  var iOSDoubleDeepLink = searchParamsOrEmpty(iOSDeepLink)['link'];
  return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * Optimistically tries to get search params from a string, or else returns an
 * empty search params object.
 */
function searchParamsOrEmpty(url) {
  if (!(url === null || url === void 0 ? void 0 : url.includes('?'))) {
    return {};
  }
  var _url$split = url.split('?'),
    _url$split2 = _toArray(_url$split),
    _ = _url$split2[0],
    rest = _url$split2.slice(1);
  return querystringDecode(rest.join('?'));
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * How long to wait for the initial auth event before concluding no
 * redirect pending
 */
var INITIAL_EVENT_TIMEOUT_MS = 500;
var CordovaPopupRedirectResolver = /*#__PURE__*/function () {
  function CordovaPopupRedirectResolver() {
    _classCallCheck(this, CordovaPopupRedirectResolver);
    this._redirectPersistence = browserSessionPersistence;
    this._shouldInitProactively = true; // This is lightweight for Cordova
    this.eventManagers = new Map();
    this.originValidationPromises = {};
    this._completeRedirectFn = _getRedirectResult;
    this._overrideRedirectResult = _overrideRedirectResult;
  }
  _createClass(CordovaPopupRedirectResolver, [{
    key: "_initialize",
    value: function () {
      var _initialize2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(auth) {
        var key, manager;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              key = auth._key();
              manager = this.eventManagers.get(key);
              if (!manager) {
                manager = new CordovaAuthEventManager(auth);
                this.eventManagers.set(key, manager);
                this.attachCallbackListeners(auth, manager);
              }
              return _context2.abrupt("return", manager);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function _initialize(_x10) {
        return _initialize2.apply(this, arguments);
      }
      return _initialize;
    }()
  }, {
    key: "_openPopup",
    value: function _openPopup(auth) {
      _fail(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */);
    }
  }, {
    key: "_openRedirect",
    value: function () {
      var _openRedirect2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(auth, provider, authType, eventId) {
        var manager, event, url, iabRef;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _checkCordovaConfiguration(auth);
              _context3.next = 3;
              return this._initialize(auth);
            case 3:
              manager = _context3.sent;
              _context3.next = 6;
              return manager.initialized();
            case 6:
              // Reset the persisted redirect states. This does not matter on Web where
              // the redirect always blows away application state entirely. On Cordova,
              // the app maintains control flow through the redirect.
              manager.resetRedirect();
              _clearRedirectOutcomes();
              _context3.next = 10;
              return this._originValidation(auth);
            case 10:
              event = _generateNewEvent(auth, authType, eventId);
              _context3.next = 13;
              return _savePartialEvent(auth, event);
            case 13:
              _context3.next = 15;
              return _generateHandlerUrl(auth, event, provider);
            case 15:
              url = _context3.sent;
              _context3.next = 18;
              return _performRedirect(url);
            case 18:
              iabRef = _context3.sent;
              return _context3.abrupt("return", _waitForAppResume(auth, manager, iabRef));
            case 20:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function _openRedirect(_x11, _x12, _x13, _x14) {
        return _openRedirect2.apply(this, arguments);
      }
      return _openRedirect;
    }()
  }, {
    key: "_isIframeWebStorageSupported",
    value: function _isIframeWebStorageSupported(_auth, _cb) {
      throw new Error('Method not implemented.');
    }
  }, {
    key: "_originValidation",
    value: function _originValidation(auth) {
      var key = auth._key();
      if (!this.originValidationPromises[key]) {
        this.originValidationPromises[key] = _validateOrigin(auth);
      }
      return this.originValidationPromises[key];
    }
  }, {
    key: "attachCallbackListeners",
    value: function attachCallbackListeners(auth, manager) {
      // Get the global plugins
      var _cordovaWindow3 = _cordovaWindow(),
        universalLinks = _cordovaWindow3.universalLinks,
        handleOpenURL = _cordovaWindow3.handleOpenURL,
        BuildInfo = _cordovaWindow3.BuildInfo;
      var noEventTimeout = setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _getAndRemoveEvent(auth);
            case 2:
              manager.onEvent(generateNoEvent());
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      })), INITIAL_EVENT_TIMEOUT_MS);
      var universalLinksCb = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(eventData) {
          var partialEvent, finalEvent;
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                // We have an event so we can clear the no event timeout
                clearTimeout(noEventTimeout);
                _context5.next = 3;
                return _getAndRemoveEvent(auth);
              case 3:
                partialEvent = _context5.sent;
                finalEvent = null;
                if (partialEvent && (eventData === null || eventData === void 0 ? void 0 : eventData['url'])) {
                  finalEvent = _eventFromPartialAndUrl(partialEvent, eventData['url']);
                }
                // If finalEvent is never filled, trigger with no event
                manager.onEvent(finalEvent || generateNoEvent());
              case 7:
              case "end":
                return _context5.stop();
            }
          }, _callee5);
        }));
        return function universalLinksCb(_x15) {
          return _ref2.apply(this, arguments);
        };
      }();
      // Universal links subscriber doesn't exist for iOS, so we need to check
      if (typeof universalLinks !== 'undefined' && typeof universalLinks.subscribe === 'function') {
        universalLinks.subscribe(null, universalLinksCb);
      }
      // iOS 7 or 8 custom URL schemes.
      // This is also the current default behavior for iOS 9+.
      // For this to work, cordova-plugin-customurlscheme needs to be installed.
      // https://github.com/EddyVerbruggen/Custom-URL-scheme
      // Do not overwrite the existing developer's URL handler.
      var existingHandleOpenURL = handleOpenURL;
      var packagePrefix = "".concat(BuildInfo.packageName.toLowerCase(), "://");
      _cordovaWindow().handleOpenURL = /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(url) {
          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                if (url.toLowerCase().startsWith(packagePrefix)) {
                  // We want this intentionally to float
                  // eslint-disable-next-line @typescript-eslint/no-floating-promises
                  universalLinksCb({
                    url: url
                  });
                }
                // Call the developer's handler if it is present.
                if (typeof existingHandleOpenURL === 'function') {
                  try {
                    existingHandleOpenURL(url);
                  } catch (e) {
                    // This is a developer error. Don't stop the flow of the SDK.
                    console.error(e);
                  }
                }
              case 2:
              case "end":
                return _context6.stop();
            }
          }, _callee6);
        }));
        return function (_x16) {
          return _ref3.apply(this, arguments);
        };
      }();
    }
  }]);
  return CordovaPopupRedirectResolver;
}();
/**
 * An implementation of {@link PopupRedirectResolver} suitable for Cordova
 * based applications.
 *
 * @public
 */
var cordovaPopupRedirectResolver = CordovaPopupRedirectResolver;
function generateNoEvent() {
  return {
    type: "unknown" /* AuthEventType.UNKNOWN */,
    eventId: null,
    sessionId: null,
    urlResponse: null,
    postBody: null,
    tenantId: null,
    error: _createError("no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */)
  };
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// This function should only be called by frameworks (e.g. FirebaseUI-web) to log their usage.
// It is not intended for direct use by developer apps. NO jsdoc here to intentionally leave it out
// of autogenerated documentation pages to reduce accidental misuse.
function addFrameworkForLogging(auth, framework) {
  _castAuth(auth)._logFramework(framework);
}
export { addFrameworkForLogging, cordovaPopupRedirectResolver };